if (!window.Eurus.loadedScript.has('info-box-cart.js')) {
  window.Eurus.loadedScript.add('info-box-cart.js');

  const infoBoxCart = () => ({
    loadingId: null,
    loadingAll: false,
    errorMessage: false,

    async addOne(id, btn) {
      if (this.loadingId || this.loadingAll) return;
      this.loadingId = id;
      try {
        await this._post([{ id: id, quantity: 1 }], btn);
      } finally {
        this.loadingId = null;
      }
    },

    async addAll() {
      if (this.loadingAll || this.loadingId) return;
      const buttons = this.$root.querySelectorAll('[data-infobox-variant-id]:not([disabled])');
      const items = Array.from(buttons).map((b) => ({
        id: b.getAttribute('data-infobox-variant-id'),
        quantity: 1,
      }));
      if (!items.length) return;
      this.loadingAll = true;
      try {
        await this._post(items);
      } finally {
        this.loadingAll = false;
      }
    },

    async _post(items) {
      const cartHelper = Alpine.store('xCartHelper');
      const sections = cartHelper.getSectionsToRender().map((section) => section.id);

      const response = await fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: items, sections: sections }),
      }).then((res) => res.json());

      if (response.status == 422) {
        this.errorMessage = response.description || true;
        return;
      }
      this.errorMessage = false;

      cartHelper.getSectionsToRender().forEach((section) => {
        const sectionElement = document.querySelector(section.selector);
        if (sectionElement && response.sections && response.sections[section.id]) {
          sectionElement.innerHTML = getSectionInnerHTML(response.sections[section.id], section.selector);
        }
      });

      if (Alpine.store('xQuickView') && Alpine.store('xQuickView').show) {
        Alpine.store('xQuickView').show = false;
      }
      if (Alpine.store('xPopup')) Alpine.store('xPopup').close();

      if (Alpine.store('xCartNoti') && Alpine.store('xCartNoti').enable) {
        Alpine.store('xCartNoti').setItem(response);
      } else {
        Alpine.store('xMiniCart').openCart();
        document.dispatchEvent(new CustomEvent('eurus:cart:redirect'));
      }

      const bubble = document.querySelector('#cart-icon-bubble span');
      if (bubble) cartHelper.currentItemCount = parseInt(bubble.innerHTML);
      document.dispatchEvent(new CustomEvent('eurus:cart:items-changed'));
    },
  });

  document.addEventListener('alpine:init', () => Alpine.data('xInfoBoxCart', infoBoxCart));
}
